import * as React from "react"
import FormLabel from "@mui/material/FormLabel"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
)

const Label = React.forwardRef<
  HTMLLabelElement,
  React.ComponentPropsWithoutRef<"label"> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <FormLabel
    component="label"
    ref={ref}
    className={cn(labelVariants(), className)}
    sx={{
      color: "inherit",
      marginBottom: 0,
      "&.Mui-focused": {
        color: "inherit",
      },
    }}
    {...props}
  />
))
Label.displayName = "Label"

export { Label }
